import { render, staticRenderFns } from "./EmergencyContact.vue?vue&type=template&id=03d1d798&"
import script from "./EmergencyContact.vue?vue&type=script&lang=js&"
export * from "./EmergencyContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports